import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl"; // Adjust this import based on your project structure
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { ToastContainer, toast } from "react-toastify"; // Import toast notifications
import "react-toastify/dist/ReactToastify.css"; // Import CSS for notifications
import { Link, Navigate } from "react-router-dom";
import logo from '../Component/img/logo.png';

const VisitorRegistration = () => {
  const navigate = useNavigate();
  const [name, setName] = useState(""); // State for storing user's name
  const [email, setEmail] = useState(""); // State for storing user's email
  const [phone, setPhone] = useState(""); // State for storing user's phone number
  const [password, setPassword] = useState(""); // State for storing user's password
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email validation regex
  const phoneRegex = /^[6-9]\d{9}$/; // Phone number validation for 10-digit numbers starting with 6-9

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission

    // Validate email format
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address."); // Show error for invalid email
      return;
    }

    // Validate phone number format
    if (!phoneRegex.test(phone)) {
      toast.error("Please enter a valid phone number."); // Show error for invalid phone
      return;
    }

    if (!name || !email || !phone || !password) {
      toast.error("Please fill in all fields."); // Show toast message for empty fields
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}register`, {
        name,
        email,
        phone,
        password,
      });

      const { visitor_id, visitor_email, visitor_name } = response.data.visitor;
      // Store visitor information in local storage
      localStorage.setItem("visitor_id", visitor_id);
      localStorage.setItem("visitor_email", visitor_email);
      localStorage.setItem("visitor_name", visitor_name);

      console.log("Local Storage Values:", localStorage);

      setError(""); // Clear error state
      const redirectUrl = localStorage.getItem("redirectUrl");
      console.log("Redirecting to:", redirectUrl);

      // Redirect user after registration
      if (redirectUrl && redirectUrl.startsWith("http")) {
        window.location.href = redirectUrl;
      } else {
        navigate(redirectUrl || "/");
      }

      localStorage.removeItem("redirectUrl");
    } catch (error) {
      if (error.response) {
        // Check for specific error code returned from the backend
        if (error.response.status === 409) {
          toast.info("User already exists. Please try logging in."); // Show toastr message for 409 error
        } else {
          toast.error(error.response.data.message || "Registration failed."); // Show toast for other errors
          console.error("Registration Error:", error); // Log error details for other status codes
        }
      } else {
        toast.error("Registration failed. Please try again."); // Generic error message
        console.error("Registration Error:", error); // Log the error for debugging
      }
    }
  };

  const handleGoogleSignIn = async (credentialResponse) => {
    const { credential } = credentialResponse; // Get the Google token from the response
    console.log("Generated Google Token:", credential); // Log the generated token

    try {
      const response = await axios.post(`${BASE_URL}auth/google-login`, {
        tokenId: credential, // Send the token ID to your backend
      });

      const { visitor_id, visitor_email, visitor_name } = response.data.visitor;
      // Store visitor information in local storage
      localStorage.setItem("visitor_id", visitor_id);
      localStorage.setItem("visitor_email", visitor_email);
      localStorage.setItem("visitor_name", visitor_name);

      console.log("Google Sign-In Local Storage Values:", localStorage);

      const redirectUrl = localStorage.getItem("redirectUrl");
      // Redirect user after Google Sign-In
      if (redirectUrl && redirectUrl.startsWith("http")) {
        window.location.href = redirectUrl;
      } else {
        navigate(redirectUrl || "/");
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error); // Log error details for further investigation
      toast.error("Google Sign-In failed. Please try again."); // Show toast for Google sign-in failure
    }
  };

  return (
    <GoogleOAuthProvider clientId="1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com">
      {" "}
      {/* Replace with your actual Google Client ID */}
      <ToastContainer /> {/* Add ToastContainer to display toast messages */}
      <div className="  bg-salt">
        <div className="row h-100">
          <div className="text-center mb-1 mt-2">
            <img src={logo} alt="" className="img-fluid logocls" />
          </div>
          <div className="col-md-5 align-content-center bg-white text-start m-auto p-3">
            <div className="lgindvcon p-4">


            <div className="mt-1 text-center">
                <button 
                    className="google-signin-btn" 
                    onClick={() => {
                        window.google?.accounts.id.initialize({
                            client_id: "1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com",
                            callback: handleGoogleSignIn,
                        });
                        window.google?.accounts.id.prompt();
                    }}
                >
                    <FontAwesomeIcon icon={faGoogle} /> Sign in with Google
                </button>
              </div>
              

              <form onSubmit={handleSubmit}>
                {" "}
                {/* Handle registration form submission */}
                <div className="mb-2">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    className="forminput"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)} // Update name state
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <input
                    type="email"
                    className="forminput"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} // Update email state
                    placeholder="Enter email"
                    required
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="phone" className="form-label">
                    Phone
                  </label>
                  <input
                    type="tel"
                    className="forminput"
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)} // Update phone state
                    placeholder="Enter phone number"
                    required
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"} // Toggle between text and password type
                    className="forminput"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} // Update password state
                    placeholder="Password"
                    required
                  />
                </div>
                <div className="mb-2 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="showPasswordCheck"
                    onChange={() => setShowPassword(!showPassword)} // Toggle password visibility
                  />
                  <label
                    className="form-check-label"
                    htmlFor="showPasswordCheck"
                  >
                    Show Password
                  </label>
                </div>
                <button type="submit" className="btnn">
                  Register
                </button>{" "}
                {/* Register button */}
                <div className="mt-3 ">
                  <small>
                    {" "}
                    <span className="form-label text-muted">
                      Have An Account?
                    </span>{" "}
                    <Link to="/login" className="text-muted">
                      Login
                    </Link>
                  </small>
                </div>
              </form>
              
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default VisitorRegistration;
